const Faqs = function () {
    const stateOpenClass = 'open';
    const itemSelector = 'faqs__item';
    const answerInnerSelector = 'faqs__answer_inner';
    const openTriggerSelector = 'faqs__question-container';
    let resizeTimeout = 0;
    /**
     * Pseudo constructor
     * @private
     */
    const __construct = () => {
        let faqOpenTriggers = document.querySelectorAll(`.js-faqs .${openTriggerSelector}`);
        if (!faqOpenTriggers.length)
            return;
        faqOpenTriggers.addEventListener('click', onClick);
        window.addEventListener('resize', () => {
            if (resizeTimeout) {
                clearTimeout(resizeTimeout);
            }
            resizeTimeout = setTimeout(afterResize, 150);
        });
    };
    /**
     * Runs after `resize` event on window global variable.
     */
    const afterResize = () => {
        let allItems = document.querySelectorAll(`.${itemSelector}`);
        if (!allItems.length)
            return;
        allItems.forEach(resizeItem);
    };
    /**
     * Resizes the items height, only if open.
     *
     * @param {HTMLElement} item
     */
    const resizeItem = (item) => {
        let innerEl = item.querySelector(`.${answerInnerSelector}`);
        if (!innerEl)
            return;
        if (isOpen(item)) {
            let newHeight = innerEl.offsetHeight + 32;
            item.style.setProperty('--answer-height', `${newHeight}px`);
        }
    };
    /**
     * Stuff to do when submenu link is clicked.
     *
     * @param {MouseEvent} e
     */
    const onClick = e => {
        /**
         * @type {HTMLElement}
         */
        let parentEl = e.currentTarget.closest(`.${itemSelector}`);
        if (!parentEl) {
            return;
        }
        /**
         * @type {HTMLElement}
         */
        let innerEl = parentEl.querySelector(`.${answerInnerSelector}`);
        let action = isOpen(parentEl) ? 'remove' : 'add';
        parentEl.classList[action](stateOpenClass);
        let newHeight = action === 'add' ? innerEl.offsetHeight + 32 : 0;
        parentEl.style.setProperty('--answer-height', `${newHeight}px`);
    };
    /**
     *
     * @param {HTMLElement} el
     * @returns {boolean}
     */
    const isOpen = el => {
        return el.classList.contains(stateOpenClass);
    };
    __construct();
};
export default Faqs;
